import React from "react";

import Actions from "./Actions";

const columns = [
  {
    name: "Topic Category",
    selector: "attributes.topic_category_name",
    sortable: true,
  },
  {
    name: "Topic Name",
    selector: "attributes.title",
    sortable: true,
  },
  {
    name: "Subtopics",
    selector: "attributes.subtopics_count",
    sortable: true,
  },

  {
    name: "Actions",
    sortable: false,
    width: "100px",
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
